// src/utility/hierarchyChainHelpers.js

/**
 * Computes the complete hierarchy chain for a node (ancestors + descendants)
 * @param {string} nodeId - The target node ID
 * @param {Object} nodeMap - Map of all nodes by ID
 * @returns {Object} chainNodeIds and chainEdgeIds Sets
 */
export function computeHierarchyChain(nodeId, nodeMap) {
  if (!nodeMap || !nodeId) {
    return { chainNodeIds: new Set(), chainEdgeIds: new Set() };
  }
  
  const chainNodeIds = new Set();
  const chainEdgeIds = new Set();
  
  // Helper: Find all descendants (children, grandchildren, etc.)
  const collectDescendants = (currentId) => {
    chainNodeIds.add(currentId);
    
    // Find all children in the node map
    const children = Object.values(nodeMap).filter(
      n => n.parentId === currentId
    );
    
    children.forEach(child => {
      chainNodeIds.add(child.id);
      chainEdgeIds.add(`${currentId}=>${child.id}#hierarchy`);
      collectDescendants(child.id);
    });
  };
  
  // Start from the target node
  chainNodeIds.add(nodeId);
  
  // Get descendants
  collectDescendants(nodeId);
  
  return { chainNodeIds, chainEdgeIds };
}